import { render } from "./Faq.vue?vue&type=template&id=e4a2b9ce&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=e4a2b9ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a2b9ce"]])

export default __exports__